import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import { CREATE_TICKET_SET, getCampaignCreateSuccessStepBar } from '../../../components/base/prompt/NextStepConfig';
import NextStepPrompt from '../../../components/base/prompt/NextStepPrompt';
import BaseForm from '../../../components/base/v2/BaseForm';
import { createCouponBreads } from '../../../config/CustomBreadConfig';
import { APIStatus, CampaignType } from '../../../config/CustomEnums';
import { PermissionCodes } from '../../../config/PermissionCodes';
import { removeCouponSessionStroage, saveCouponToSessionStorage } from '../../../models/CreateCouponModel';
import { createAction } from '../../../utils';
import CreateTicketStepOne from './CreateTicketStepOne';
import { TAB_LIST_OF_TICKET_SETS } from './TicketsList';
import Loading from 'components/base/Loading';


function CreateTicketSet({
  stepConfig,
  currentStep,
  formHasSubmitted,
  couponTemplate,
  hasUpdatedDefaultValues,
  createCouponTemplateStatus,
  showEditSuccessPrompt,
  couponStores,
  detailLoading,
}) {
  const location = useLocation();
  const params = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = params;

  const stepSet = [
    <CreateTicketStepOne />,
  ];

  useEffect(() => {
    const newItem = location.state || {};
    if (id) {
      dispatch(
        createAction('couponList/getCouponSet')({
          couponSetPK: params.id,
          ...newItem,
        }),
      );
    } else {
      // ALLEN TODO: loadTicketFromCookie
      dispatch(
        createAction('createCoupon/loadCouponFromCookie')({ ...newItem }),
      );
      dispatch(createAction('brand/getAllBrands')({}));
      dispatch(createAction('mall/getPagedMallList')({}));
      dispatch(
        createAction('storeCategoryList/getStoreCategoryList')({
          pageSize: 100,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(createAction('language/getList')({ isSelectorLoad: true }));
    return () => {
      dispatch({ type: 'createCoupon/clearState' });
      dispatch({ type: 'storeModel/clearData' });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!id && couponTemplate.couponStores) {
      dispatch(
        createAction('storeModel/updateState')({
          couponStores: couponTemplate.couponStores,
        }),
      );
    }
  }, [id, couponTemplate]);

  const goToTicketList = () => {
    history.push({ pathname: '/tickets', hash: TAB_LIST_OF_TICKET_SETS });
  };

  const getNextStepConfig = () => {
    return {
      title: 'Successfully Create!',
      description: 'The ticket set is successfully created.\n Let’s create an event based on these tickets or you can generate a single ticket to a customer.',
      type: CREATE_TICKET_SET,
      stepNames: getCampaignCreateSuccessStepBar(
        CampaignType.ticketCampaign,
        true,
      ),
      buttons: [
        {
          text: 'Create Event',
          action: () =>
            history.push({
              pathname: '/events/create',
            }),
          requires: PermissionCodes.addCampaign,
        },
        {
          text: 'Maybe Later',
          action: goToTicketList,
        },
      ],
    };
  };

  if (detailLoading === APIStatus.calling) {
    return <Loading />
  }
  return (
    <>
      <BaseForm
        defaultValues={couponTemplate}
        hasUpdatedDefaultValues={hasUpdatedDefaultValues}
        formHasSubmitted={formHasSubmitted}
        tempSave={(save, getValues) => {
          if (save) {
            saveCouponToSessionStorage({
              ...getValues(),
              couponStores,
            });
          } else {
            removeCouponSessionStroage();
          }
        }}
        nextStepConfig={{
          title: getNextStepConfig().title,
          description: getNextStepConfig().description,
          steps: {
            stepNames: getNextStepConfig().stepNames,
            current: getNextStepConfig().type,
          },
          buttons: getNextStepConfig().buttons,
          onHide: () => { },
        }}
        showFinishPop={createCouponTemplateStatus === APIStatus.success}
        continueCreateConfig={{
          onConfirm: () => {
            history.push(history.location.state?.from);
          },
          onCancel: goToTicketList,
          onClose: goToTicketList,
        }}
        // sessionDataKey={sessionDataKey}
        content={stepSet}
        currentStep={0}
        breadcrumb={
          <CustomBreadcrumb breadcrumbs={createCouponBreads(params?.id, true)} />
        }
        stepsConfig={[]}
        caution={{
          detail:
            'Ticket set stores the content and controls a list of ticket.After you create a ticket set, you can general a list of single tickets for your customers',
          title: 'Ticket Set',
        }}
      />
      <NextStepPrompt
        show={showEditSuccessPrompt}
        title="Successfully Saved!"
        description="Ticket is successfully saved."
        steps={null}
        buttons={[
          {
            text: 'Back to ticket listing page',
            action: goToTicketList,
            requires: PermissionCodes.viewCoupon,
          },
          {
            text: 'Continue edit',
            action: () => {
              dispatch({ type: 'createCoupon/hideEditorSuccessPrompt' });
            },
          },
        ]}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  stepConfig: state.createCoupon.stepConfig,
  currentStep: state.createCoupon.currentStep,
  formHasSubmitted: state.createCoupon.formHasSubmitted,
  couponTemplate: state.createCoupon.couponTemplate,
  hasUpdatedDefaultValues: state.createCoupon.hasUpdatedDefaultValues,
  createCouponTemplateStatus: state.createCoupon.createCouponTemplateStatus,
  showEditSuccessPrompt: state.createCoupon.showEditSuccessPrompt,
  couponStores: state.storeModel.couponStores,
  detailLoading: state.couponList.detailLoading,
});

export default connect(mapPropsToState)(CreateTicketSet);